export default __webpack_public_path__ + "static/media/ic_fast_forward.f3a0742c.svg";